import React from 'react'
import Menu from './Includes/Menu'

function Main({ per,setIsloggedin }) {
  return <Menu per={per} logoutUser={setIsloggedin} />;
}

export default Main
